// import services

import BaseCommand from "./baseCommand";
import SubCommandFactory from "./subcommands/subCommandFactory";
import { COMMAND_TYPES } from "../constants/common";

class AddComponentCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
    const { mode, component: { type } = {} } = componentData;
    const isPDF = false; // no seperate implementation for pdf doc or template. but can be extended
    this.subCommand = SubCommandFactory.getSubCommandInstance(
      COMMAND_TYPES.ADD_COMPONENT,
      type,
      mode,
      isPDF,
      componentData,
    );
  }

  execute() {
    this.subCommand.execute();
  }

  undo() {
    this.subCommand.undo();
  }
}

export default AddComponentCommand;
